<template>
  <div class="view-switcher" role="tablist">
    <button
      v-for="v in normalizedViews"
      :key="v.value"
      type="button"
      class="vs-item"
      :class="{ 'is-active': v.value === modelValue }"
      role="tab"
      :aria-selected="v.value === modelValue"
      @click="select(v.value)"
    >
      {{ v.label }}
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ViewSwitcher',
  props: {
    modelValue: { type: String, default: '' },
    // ['month','week','day'] 또는 [{value,label}]
    views: { type: Array, default: () => [] }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const LABELS = { month: '월', week: '주', day: '일', agenda: '목록', list: '목록', board: '칸반보드', calendar: '캘린더' }
    const normalizedViews = computed(() =>
      props.views.map((v) =>
        typeof v === 'string' ? { value: v, label: LABELS[v] || v } : v
      )
    )
    function select(value) {
      if (value === props.modelValue) return
      emit('update:modelValue', value)
      emit('change', value)
    }
    return { normalizedViews, select }
  }
}
</script>

<style scoped>
.view-switcher {
  display: inline-flex;
  background: var(--color-surface-2);
  border-radius: var(--r-md);
  padding: 3px;
  gap: 2px;
}

.vs-item {
  border: none;
  background: transparent;
  padding: 0 14px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: calc(var(--r-md) - 3px); /* 트랙 --r-md 에서 padding 3px 안쪽 */
  font-family: inherit;
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color var(--dur) var(--ease), background var(--dur) var(--ease);
  white-space: nowrap;
  line-height: 1.4;
}

.vs-item:hover {
  color: var(--color-text);
}

.vs-item.is-active {
  background: var(--color-surface);
  color: var(--color-primary);
  font-weight: var(--fw-semibold);
  box-shadow: var(--sh-1);
}

@media (max-width: 767px) {
  .view-switcher {
    display: flex;
    width: 100%;
  }
  /* 모바일에서는 탭 대상이므로 --tap-min 아래로 내리지 않는다 */
  .vs-item {
    flex: 1;
    height: var(--tap-min);
    padding: 0;
    font-size: var(--fs-md);
  }
}
</style>
